class FlickitySlider extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".main-carousel");
    this.controls = this.closest("section").querySelector(".flickity-controls");
    this.buttons = this.controls.querySelectorAll("button");

    this.buttons.forEach((button) =>
      button.addEventListener("click", this.changeSlide.bind(this))
    );

    this.flickitySlider = new Flickity(this.carousel, {
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
    });
  }

  changeSlide(event) {
    var button = event.target.closest("button");
    button.classList.contains("prev")
      ? this.flickitySlider.previous(true, false)
      : this.flickitySlider.next(true, false);
  }

  refresh() {
    new Flickity(this.carousel, {
      wrapAround: true,
    });
  }
}
customElements.define("flickity-slider", FlickitySlider);

class FlickPatch {
  //  Flick Carousel ARIA-HIDDEN observer
  constructor(_d, _sQ) {
    this._d = _d;
    this._sQ = _sQ;
    this.aF = [];
    this.aObs = [];
  }
  init() {
    //
    this.aF = Array.from(this._d.querySelectorAll(this._sQ));
    if (this.aF.length) {
      this.aObs = [];
      this.aF.forEach((eF) => {
        const oObs = new MutationObserver(flickPatch.removeAttr);
        oObs.observe(eF, { attributes: true, childList: true, subtree: true });
        this.aObs.push(oObs);
      });
    }
    return this;
  }
  removeAttr(aObs) {
    //
    if (aObs.length) {
      aObs.forEach((elO) => {
        if (elO?.target) {
          [...elO.target.querySelectorAll("[aria-hidden='true']")].forEach(
            (eH) => {
              eH.removeAttribute("aria-hidden");
            }
          );
        }
      });
    }
  }
}
//. Usage
let flickPatch = {};
document.addEventListener("DOMContentLoaded", (ev) => {
  setTimeout(() => {
    flickPatch = new FlickPatch(document, ".flickity-slider");
    flickPatch.init();
  }, 8e3);
});
